// extracted by mini-css-extract-plugin
export default {"live":"style_live__tjq-f"};